import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";
import ProjectionLine from '../components/ProjectionLine';

export class BeerpongScene extends MinigameScene {
    //Images

    //values
    private speed = 0.15;
    private ballMass = 100;
    private cupMass = 800;
    private ballScale = 0.75;
    private gravityScale = 1.81;

    private ballStartPos = {x: 236, y: 211};
    private maxBallCupDistance = 22;

    private physicsShapes;

    private cupsConfig = [
        {x: 752, y: 307, scale: 0.75},
        {x: 606, y: 307, scale: 0.75},
        {x: 680, y: 307, scale: 0.75},
    ];

    private aimingConfig = {
        from: {x: 284, y: 127},
        to: {x: 327, y: 114},
        duration: 1500
    }

    private cupBackYOffset = 50;
    private cupBackXOffset = 3;

    //logic vars
    private balls !: object[];
    private projectionLine !: ProjectionLine;
    private cups: object[] = [];
    private allCupsFilled = false;
    private aimingImage !: Phaser.GameObjects.Image;
    private endTimer :Phaser.Time.TimerEvent = null;


    constructor(){
        super ({
            sceneName: CONST.SCENES.BEERPONG,
            duration: 10000,
            startScreenColor: 0xFDFF62,
            startText: "SPORTS!",
            startTextColor: 0x323232,
            endScreen: CONST.BEERPONG.END,
            nextScene: CONST.SCENES.COFFEE,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 75, scale: 1.25},
                normalWithSkip: {x: 272, y: 75, scale: 1.25},
                skip: {x: 540, y: 75, scale: 1.25}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.balls = [];
        this.projectionLine = null;
        this.cups = [];
        this.allCupsFilled = false;
        this.endTimer = null;
        this.aimingImage = null;
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.BEERPONG.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(520, 410, CONST.BEERPONG.DUNKTEXT).setDepth(1);

        this.initPhysics();

        this.input.on('pointerdown', (pointer) => {
            //console.log("pointer down x " + pointer.x + " y " + pointer.y);
            this.throwBall();
        })

        this.initAiming();

       this.createCups();
    }

    private initAiming(){
        this.aimingImage = this.add.image(this.aimingConfig.from.x, this.aimingConfig.from.y, CONST.TALK.NOTE_1)
                                    .setDepth(100)
                                    .setScale(0.5)
                                    .setVisible(false);
        this.tweens.add({
            targets: this.aimingImage,
            x: this.aimingConfig.to.x,//- this.aimingConfig.from.x,            
            y: this.aimingConfig.to.y,// - this.aimingConfig.from.y,              
            ease: 'Sine.easeInOut',
            duration: this.aimingConfig.duration,
            repeat: -1,           
            yoyo: true
        });        

        this.projectionLine = new ProjectionLine(this, this.ballStartPos.x, this.ballStartPos.y, this.ballScale, this.ballMass, this.speed, this.gravityScale, 260);
    }

    private createCups() {

        this.cupsConfig.forEach(config => {
            this.add.image(config.x - this.cupBackXOffset, config.y - this.cupBackYOffset, CONST.BEERPONG.CUP_BACK)
                        .setDepth(3)
                        .setScale(config.scale);

            var cup = this.matter.add.image(config.x, config.y, CONST.BEERPONG.CUP_FRONT, null, {shape: this.physicsShapes.FRONT})
                            .setDepth(9)
                            .setStatic(true) //TODO: uncomment this to make cups movable
                            .setFriction(0.7)
                            .setMass(this.cupMass)
                            .setScale(config.scale); 
            
            cup.label = 'cup' + config.x;
        
            this.cups.push(cup);
        });
    }

    private initPhysics(){
        this.physicsShapes = this.cache.json.get(CONST.PHYSICS.BEERPONG);

        this.matter.add.rectangle(526, 337, 610, 25, {
            isStatic: true,
        });

        this.matter.world.setGravity(0, this.gravityScale);
    };

    private throwBall(){
        var ball = this.createBall();

        ball.isShot = false;
        ball.update = (delta: number) => {
            if (!ball.isShot){
                ball.isShot = true;
                var force = this.GetSpeedFrom({x: ball.x, y: ball.y},
                    {x: this.aimingImage.x, y: this.aimingImage.y});
                var multiplier = 0.62;
                ball.setStatic(false);
                //ball.applyForce(new Phaser.Math.Vector2(multiplier*force.x, multiplier*force.y));
                ball.setVelocity(force.x, force.y);
            }
        };

        this.balls.push(ball);
    }

    private createBall() : Phaser.Physics.Matter.Image {
        return this.matter.add.image(this.ballStartPos.x,
                              this.ballStartPos.y, 
                              CONST.BEERPONG.BALL,
                              null,
                              //{chamfer: {radius: 20}}
                              {label: 'ball', isStatic(true)},
                              )
                        .setFrictionAir(0)
                        .setDepth(5)
                        .setCircle()
                        .setBounce(0.7)
                        .setFriction(0.4)
                        .setScale(this.ballScale, this.ballScale)
                        .setMass(this.ballMass)
                        .setStatic(true)
                        ;
    }

    private GetSpeedFrom(from: {x:number, y: number}, to: {x:number, y: number}){
        return {x: (to.x - from.x) * this.speed, y: (to.y - from.y) * this.speed};
    }

    _update(time: number, delta: number){
        this.balls.forEach(ball => {ball.update(delta)});

        this.projectionLine.updateProjectionPoints(this.aimingImage.x, this.aimingImage.y);

        this.checkForWin();
    }

    private checkForWin(){
        if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        this.updateCups();

        if (this.endTimer == null && this.allCupsFilled){
           this.endTimer = this.time.delayedCall(1000, () => {
                this.tryTriggerWin();
            }, null, this);
        }
        //console.log("Cup1: " + this.cups[0].filled + " cup2: " + this.cups[1].filled + " cup3: " + this.cups[2].filled);
    }

    private tryTriggerWin(){
        this.updateCups();
        if (this.allCupsFilled){
            this.triggerWin();
        }
    }

    private updateCups(){
        this.cups.forEach(cup => {
            cup.filled = false;
            for (let ball of this.balls){
                if (Phaser.Math.Distance.Between(ball.x, ball.y, cup.x, cup.y) < this.maxBallCupDistance){
                    
                    cup.filled = true;
                    break;
                }
            }
        });

        this.allCupsFilled = true
        for(var cup of this.cups){
            if (!cup.filled){
                this.allCupsFilled = false;
                break;
            }
        }
    }

    _timeout(){
        if (this.endTimer != null) this.endTimer.destroy();

        this.updateCups();
        if (this.allCupsFilled){
            this.winGame(0);
        } else {
            this.loseGame();
        }
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(0);
    }
}